import * as Types from "../../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetOrganisationExposureLimitsQueryVariables = Types.Exact<{
  organisation_id: Types.Scalars["Int"];
}>;

export type GetOrganisationExposureLimitsQuery = {
  __typename?: "query_root";
} & {
  organisations_by_pk?: Types.Maybe<
    { __typename?: "organisations" } & {
      organisation_bank_exposure_limits: Array<
        { __typename?: "organisation_bank_exposure_limits" } & Pick<
          Types.Organisation_Bank_Exposure_Limits,
          "id" | "organisation_id" | "exposure_limit"
        > & {
            bank: { __typename?: "banks" } & Pick<Types.Banks, "id" | "name">;
          }
      >;
      banks: Array<
        { __typename?: "organisation_banks" } & {
          bank: { __typename?: "banks" } & Pick<Types.Banks, "id" | "name">;
        }
      >;
    }
  >;
  banks: Array<
    { __typename?: "banks" } & Pick<Types.Banks, "id" | "name"> & {
        image?: Types.Maybe<
          { __typename?: "uploads" } & Pick<Types.Uploads, "public_url">
        >;
      }
  >;
};

export const GetOrganisationExposureLimitsDocument = gql`
  query GetOrganisationExposureLimits($organisation_id: Int!) {
    organisations_by_pk(id: $organisation_id) {
      organisation_bank_exposure_limits {
        id
        organisation_id
        bank {
          id
          name
        }
        exposure_limit
      }
      banks(order_by: { bank: { name: asc } }) {
        bank {
          id
          name
        }
      }
    }
    banks(order_by: { name: asc }) {
      id
      name
      image {
        public_url
      }
    }
  }
`;

export function useGetOrganisationExposureLimitsQuery(
  options: Omit<
    Urql.UseQueryArgs<GetOrganisationExposureLimitsQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<GetOrganisationExposureLimitsQuery>({
    query: GetOrganisationExposureLimitsDocument,
    ...options,
  });
}
